import React, { FunctionComponent } from 'react'

import logoTmov from '../../assets/images/logoTmov.svg'
import { Container, Logo } from './styles'
import SelectFrotista from '../SelectFrotista'

const Header: FunctionComponent = () => (
  <Container>
    <Logo src={logoTmov} />
    <SelectFrotista />
  </Container>
)

export default Header
